import React, { useEffect } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import useAuth from '../auth/UseAuth';
import { settings } from '../helpers/main';

export default function PublicRouter({ component: Component, ...rest }) {
    //#region variables

    const auth = useAuth();
    const location = useLocation();
    // const from = location.state?.from || '/';
    let from = location.state?.from;
    const redirectUrl = localStorage.getItem(settings.localStorage.redirectId);
    from = from || redirectUrl || '/';

    //#endregion variables
    useEffect(() => {
    }, []);
    return (
        <Route {...rest}>
            {!auth?.isLoged({ subMethod: 'PublicRouter' })?.result ? (<Component />) : (<Redirect to={from} />)}
        </Route>
    )
}